/* ============================================================
   FORCE — theme JS
   Cart drawer (AJAX), quantity selectors, Protocol plan selector,
   Ciencia lightbox, hero video mute enforcement.
   ============================================================ */
(function () {
  'use strict';

  /* ---------- Money ---------- */
  function formatMoney(cents) {
    var format = (window.FORCE && window.FORCE.moneyFormat) || '${{amount_no_decimals_with_comma_separator}}';
    var value = '';
    function withDelims(number, decimals, thousands, decimal) {
      thousands = thousands || '.';
      decimal = decimal || '.';
      var fixed = (number / 100).toFixed(decimals);
      var parts = fixed.split('.');
      var whole = parts[0].replace(/(\d)(?=(\d{3})+$)/g, '$1' + thousands);
      return decimals ? whole + decimal + parts[1] : whole;
    }
    var m = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var placeholder = m ? m[1] : 'amount';
    switch (placeholder) {
      case 'amount': value = withDelims(cents, 2); break;
      case 'amount_no_decimals': value = withDelims(cents, 0); break;
      case 'amount_with_comma_separator': value = withDelims(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelims(cents, 0, '.'); break;
      case 'amount_with_apostrophe_separator': value = withDelims(cents, 2, "'"); break;
      default: value = withDelims(cents, 0, '.');
    }
    return format.replace(/\{\{\s*\w+\s*\}\}/, value);
  }
  window.FORCE = window.FORCE || {};
  window.FORCE.formatMoney = formatMoney;

  /* ---------- Cart drawer ---------- */
  var drawerRoot = function () { return document.getElementById('CartDrawerRoot'); };

  function openDrawer() {
    var root = drawerRoot();
    if (!root) return;
    root.classList.add('is-open');
    root.removeAttribute('hidden');
    document.documentElement.style.overflow = 'hidden';
  }
  function closeDrawer() {
    var root = drawerRoot();
    if (!root) return;
    root.classList.remove('is-open');
    root.setAttribute('hidden', 'hidden');
    document.documentElement.style.overflow = '';
  }

  function refreshDrawer(open) {
    return fetch('/?sections=cart-drawer')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data['cart-drawer'];
        if (!html) return;
        var root = drawerRoot();
        var wasOpen = root && root.classList.contains('is-open');
        var holder = document.createElement('div');
        holder.innerHTML = html;
        var fresh = holder.querySelector('#CartDrawerRoot');
        var section = document.getElementById('shopify-section-cart-drawer');
        if (section && fresh) {
          section.innerHTML = holder.querySelector('.shopify-section') ? holder.querySelector('.shopify-section').innerHTML : html;
        }
        updateCount();
        if (open || wasOpen) openDrawer();
      });
  }

  function updateCount() {
    fetch((window.FORCE.cartUrl || '/cart') + '.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.setAttribute('data-count', cart.item_count);
        });
      });
  }

  function ajaxAdd(body) {
    return fetch((window.FORCE.cartAddUrl || '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
      body: body
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (e) { throw e; });
      return r.json();
    });
  }

  /* ---------- Global click handling ---------- */
  document.addEventListener('click', function (e) {
    var t;

    if ((t = e.target.closest('[data-cart-open]'))) {
      e.preventDefault();
      refreshDrawer(true);
      return;
    }
    if (e.target.closest('[data-cart-close]')) {
      e.preventDefault();
      closeDrawer();
      return;
    }

    /* Remove line from drawer */
    if ((t = e.target.closest('[data-line-remove]'))) {
      e.preventDefault();
      var line = t.getAttribute('data-line-remove');
      fetch((window.FORCE.cartChangeUrl || '/cart/change') + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ line: Number(line), quantity: 0 })
      }).then(function () { refreshDrawer(true); });
      return;
    }

    /* Drawer line quantity +/- */
    if ((t = e.target.closest('[data-line-plus], [data-line-minus]'))) {
      e.preventDefault();
      var lineNo = Number(t.getAttribute('data-line-plus') || t.getAttribute('data-line-minus'));
      var qty = parseInt(t.getAttribute('data-qty'), 10) || 1;
      qty = t.hasAttribute('data-line-plus') ? qty + 1 : qty - 1;
      if (qty < 0) qty = 0;
      fetch((window.FORCE.cartChangeUrl || '/cart/change') + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ line: lineNo, quantity: qty })
      }).then(function () { refreshDrawer(true); });
      return;
    }

    /* Quantity +/- */
    if ((t = e.target.closest('[data-qty-plus], [data-qty-minus]'))) {
      var wrap = t.closest('.f-qty');
      var input = wrap && wrap.querySelector('input');
      if (input) {
        var val = parseInt(input.value, 10) || 1;
        val = t.hasAttribute('data-qty-plus') ? val + 1 : Math.max(1, val - 1);
        input.value = val;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
      return;
    }

    /* Plan selector */
    if ((t = e.target.closest('.f-plan[data-months]'))) {
      var selector = t.closest('[data-plan-selector]');
      if (selector) selectPlan(selector, t);
      return;
    }

    /* Protocol CTA */
    if ((t = e.target.closest('[data-plan-cta]'))) {
      var sel = t.closest('[data-plan-selector]') || document.querySelector('[data-plan-selector]');
      var current = sel && sel.querySelector('.f-plan.is-selected');
      var variantId = current && current.getAttribute('data-variant-id');
      if (variantId) {
        e.preventDefault();
        var fd = new FormData();
        fd.append('id', variantId);
        fd.append('quantity', 1);
        ajaxAdd(fd).then(function () { refreshDrawer(true); }).catch(function (err) {
          alert((err && err.description) || 'No se pudo agregar al carro.');
        });
      }
      /* No variant configured: fall through to the button's href */
      return;
    }

    /* Ciencia lightbox */
    if ((t = e.target.closest('[data-lightbox-open]'))) {
      e.preventDefault();
      openLightbox(t);
      return;
    }
    if (e.target.closest('[data-lightbox-close]') || (e.target.classList && e.target.classList.contains('f-lightbox'))) {
      closeLightbox();
      return;
    }
    if ((t = e.target.closest('[data-lightbox-prev], [data-lightbox-next]'))) {
      stepLightbox(t.hasAttribute('data-lightbox-next') ? 1 : -1);
      return;
    }
  });

  /* ---------- AJAX product forms ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-ajax-add]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    if (btn) btn.classList.add('f-btn--disabled');
    ajaxAdd(new FormData(form))
      .then(function () { return refreshDrawer(true); })
      .catch(function (err) {
        alert((err && err.description) || 'No se pudo agregar al carro.');
      })
      .then(function () { if (btn) btn.classList.remove('f-btn--disabled'); });
  });

  /* ---------- Protocol plan selector ---------- */
  /* Fuente de verdad: el precio de la variante del producto (lo que realmente
     se cobra en el checkout). El total mostrado en la card SIEMPRE coincide con
     lo que se cobra. El pago es único; las cuotas (hasta 12 sin interés) las
     elige el cliente en Webpay/Flow. */
  function selectPlan(selector, planBtn) {
    selector.querySelectorAll('.f-plan').forEach(function (b) { b.classList.remove('is-selected'); });
    planBtn.classList.add('is-selected');

    var listTotal = parseInt(selector.getAttribute('data-list-total'), 10) || 0;
    var pct = parseFloat(planBtn.getAttribute('data-pct')) || 0;
    var months = parseInt(planBtn.getAttribute('data-months'), 10) || 1;

    var variantPrice = parseInt(planBtn.getAttribute('data-variant-price'), 10);
    var variantCompare = parseInt(planBtn.getAttribute('data-variant-compare'), 10);

    var total, listPlan;
    if (variantPrice && variantPrice > 0) {
      total = variantPrice;
      listPlan = (variantCompare && variantCompare > total) ? variantCompare : Math.round(listTotal * months);
    } else {
      total = Math.round(listTotal * months * (1 - pct / 100));
      listPlan = Math.round(listTotal * months);
    }
    var perMonth = Math.round(total / months);
    var saving = listPlan - total;

    var q = function (s) { return selector.querySelectorAll(s); };
    q('[data-sel-label]').forEach(function (el) { el.textContent = planBtn.getAttribute('data-label') || ''; });
    q('[data-sel-permonth]').forEach(function (el) { el.textContent = formatMoney(perMonth); });
    q('[data-sel-total]').forEach(function (el) { el.textContent = formatMoney(total); });
    q('[data-sel-listplan]').forEach(function (el) { el.textContent = formatMoney(listPlan); });
    q('[data-sel-saving]').forEach(function (el) { el.textContent = formatMoney(saving); });
  }

  function initPlanSelectors() {
    document.querySelectorAll('[data-plan-selector]').forEach(function (selector) {
      var listTotal = parseInt(selector.getAttribute('data-list-total'), 10) || 0;
      selector.querySelectorAll('.f-plan').forEach(function (btn) {
        var pct = parseFloat(btn.getAttribute('data-pct')) || 0;
        var months = parseInt(btn.getAttribute('data-months'), 10) || 1;
        var variantPrice = parseInt(btn.getAttribute('data-variant-price'), 10);
        var perMonth = (variantPrice && variantPrice > 0)
          ? Math.round(variantPrice / months)
          : Math.round(listTotal * (1 - pct / 100));
        var el = btn.querySelector('[data-plan-permonth]');
        if (el) el.textContent = formatMoney(perMonth);
        var elDay = btn.querySelector('[data-plan-perday]');
        if (elDay) elDay.textContent = '≈ ' + formatMoney(Math.round(perMonth / 30)) + ' por día';
      });
      var initial = selector.querySelector('.f-plan.is-selected') || selector.querySelector('.f-plan[data-default]') || selector.querySelector('.f-plan');
      if (initial) selectPlan(selector, initial);
    });
  }

  /* ---------- Ciencia lightbox ---------- */
  var lightboxState = { images: [], index: 0, title: '' };

  function lightboxEl() { return document.getElementById('ForceLightbox'); }

  function renderLightbox() {
    var box = lightboxEl();
    if (!box) return;
    var img = box.querySelector('[data-lightbox-img]');
    var counter = 'Lámina ' + (lightboxState.index + 1) + ' / ' + lightboxState.images.length;
    img.src = lightboxState.images[lightboxState.index];
    img.alt = lightboxState.title + ' — ' + counter;
    box.querySelectorAll('[data-lightbox-counter]').forEach(function (el) {
      var n = lightboxState.index + 1;
      el.textContent = (n < 10 ? '0' + n : n) + ' / ' + (lightboxState.images.length < 10 ? '0' + lightboxState.images.length : lightboxState.images.length);
    });
    box.querySelectorAll('[data-lightbox-title]').forEach(function (el) { el.textContent = lightboxState.title; });
  }
  function openLightbox(trigger) {
    var box = lightboxEl();
    if (!box) return;
    try {
      lightboxState.images = JSON.parse(trigger.getAttribute('data-images') || '[]');
    } catch (err) { lightboxState.images = []; }
    if (!lightboxState.images.length) return;
    lightboxState.index = 0;
    lightboxState.title = trigger.getAttribute('data-title') || '';
    var cta = box.querySelector('[data-lightbox-cta]');
    if (cta) {
      var url = trigger.getAttribute('data-product-url');
      var label = trigger.getAttribute('data-cta-label');
      if (url) { cta.setAttribute('href', url); cta.textContent = label || 'Ver producto'; cta.removeAttribute('hidden'); }
      else { cta.setAttribute('hidden', 'hidden'); }
    }
    renderLightbox();
    box.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
  }
  function closeLightbox() {
    var box = lightboxEl();
    if (!box || !box.classList.contains('is-open')) return;
    box.classList.remove('is-open');
    document.documentElement.style.overflow = '';
  }
  function stepLightbox(dir) {
    var n = lightboxState.images.length;
    if (!n) return;
    lightboxState.index = (lightboxState.index + dir + n) % n;
    renderLightbox();
  }
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeLightbox(); closeDrawer(); }
    var box = lightboxEl();
    if (box && box.classList.contains('is-open')) {
      if (e.key === 'ArrowRight') stepLightbox(1);
      if (e.key === 'ArrowLeft') stepLightbox(-1);
    }
  });

  /* ---------- Hero video: force muted (autoplay requirement) ---------- */
  function muteVideos() {
    document.querySelectorAll('video[data-force-muted]').forEach(function (v) {
      v.muted = true; v.defaultMuted = true; v.volume = 0;
      var p = v.play();
      if (p && p.catch) p.catch(function () {});
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    muteVideos();
    initPlanSelectors();
    updateCount();
  });
})();
